import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from './HomePage';
import WhatIsToon from './pages/WhatIsToon';
import JsonVsToon from './pages/JsonVsToon';
import ReduceLlmTokenCosts from './pages/ReduceLlmTokenCosts';
import ToonFormatSpec from './pages/ToonFormatSpec';

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/what-is-toon" element={<WhatIsToon />} />
      <Route path="/json-vs-toon" element={<JsonVsToon />} />
      <Route path="/reduce-llm-token-costs" element={<ReduceLlmTokenCosts />} />
      <Route path="/toon-format-spec" element={<ToonFormatSpec />} />
    </Routes>
  );
}

export default App;
